/* Preserve native purchase handlers and coordinate the new visual navigation. */
(() => {
  const scrollToPurchase = () => {
    if (location.hash !== '#purchase') return;
    const purchase = document.getElementById('purchase');
    if (!purchase) return;
    requestAnimationFrame(() => requestAnimationFrame(() => purchase.scrollIntoView({block:'start',behavior:'instant'})));
  };
  document.addEventListener('DOMContentLoaded',scrollToPurchase,{once:true});
  if(document.readyState!=='loading')scrollToPurchase();
  addEventListener('hashchange',scrollToPurchase);
})();
